import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import "../Modules/home/home.css";
import Environments from "../Modules/home/Environments";
import Footer from "../Modules/Footer";
import Hero from "../Modules/home/Hero";
import Mission from "../Modules/home/Mission";
import NavigationBar from "../Modules/NavigationBar";
import Product from "../Modules/home/Product";
import Testimonials from "../Modules/home/testimonials";

export default function Home() {
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Homepage"}</title>
			</Helmet>
			<NavigationBar />
			<Hero title="" video />

			<Container className="eo-products">
				<p className="eo-section__overline">Products</p>
				<h2 className="eo-section__title">Choose your protection.</h2>
				<div className="eo-products__grid">
					<Product
						img="/images/home/protect-case.jpg"
						alt="EarsOnly Protect Earbuds in their open Charging Case"
						title="/brand/wordmarks/protect-black.svg"
						text="True-Wireless custom fit hearing protection with dynamic damping. Ability to communicate in noisy environments and enjoy high quality music at safe sound levels."
						accent
						orderLink="/contact"
						moreLink="/protect"
					/>
					<Product
						img="/images/redux/render-cord.jpg"
						fill
						alt="EarsOnly Redux earplugs"
						title="/brand/wordmarks/redux-black.svg"
						text="Redux earplugs are engineered for both professionals and dedicated enthusiasts who demand high performance and protection."
						accent
						orderLink="/contact"
						moreLink="/redux"
					/>
				</div>
			</Container>

			<Environments />
			<Mission />
			<Testimonials />
			<Footer />
		</>
	);
}
